<template>
  <div class="root d-inline-block">
    <div class="input-group">
      <div>
        <div>
          <button v-if="mode==='view'" class="btn btn-secondary" @click="openModal('view')">
            <i class="icon-bd-edit"></i>
          </button>
          <button v-if="mode==='create'" class="btn btn-secondary" @click="openModal('create')">
            <i class="icon-bd-book-plus"></i>
          </button>
        </div>
              </div>

    </div>
    <b-modal
      ref="ProductDetaiModal"
      id="modal-center"
      class="accounting-modal"
      centered
      size="xl"
      :title="modalTitle"
      :ok-title="'ذخیره'"
      :cancel-title="'لغو'"
      @ok="onProductDetaiModalOk"
    >
      <!--<div class="row mb-2">-->
      <!--<p class="small">عنوان 1 :</p>-->
      <!--<p class="small">عنوان 2 :</p>-->
      <!--<p class="small">عنوان 3 :</p>-->
      <!--</div>-->
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام دوم</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.standardName"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام انگلیسی</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.standardName2"
              type="text"
              class="form-control"
            >
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام فاکتور مشتری</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.customerName"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کد فنی محصول</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.isoCode"
              type="text"
              class="form-control"
            >
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>بارکد</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.barcode"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>رنگ</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.color"
              type="text"
              class="form-control"
            >
          </div>
        </div>
      </div>
      <hr/>
      <h6 class="text-center w-100">اندازه ها و وزن یک عدد محصول را وارد کنید. در صورتی که محصول را به متر یا وزن تعریف کرده اید مقدار آن را یک وارد کنید</h6>
      <div class="row mb-2">
        <div class="col-2  p-1">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>طول(متر)</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.tool"
              type="number"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-2  p-1">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>عرض(متر)</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.arz"
              type="number"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-3  p-1">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ضخامت(میلیمتر)</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.ghotr"
              type="number"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-2 p-1">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ارتفاع(متر)</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.ertefa"
              type="number"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-3  p-1">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>وزن(کیلوگرم)</span>
              </div>
            </div>
            <input
              ref="server"
              v-model="detailModel.weight"
              type="number"
              class="form-control"
            >
          </div>
        </div>
      </div>
      <hr/>
      <h6 class="text-center w-100"  v-if="mode==='view'">موجودی محصول با توجه به ابعاد و وزن وارد شده.
        موجودی فعلی
        {{product.stockQuantity}}
        {{product.unit.unitValue}}
      </h6>
      <div class="row mb-2"  v-if="mode==='view'">

        <div class="col-3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>متر طول</span>
              </div>
            </div>
            <input
              disabled
              ref="server"
              v-model="detailModel.metrtool"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>متر مربع</span>
              </div>
            </div>
            <input
              disabled
              ref="server"
              v-model="detailModel.metrmoraba"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>حجم</span>
              </div>
            </div>
            <input
              disabled
              ref="server"
              v-model="detailModel.hajm"
              type="text"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-3">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>موجودی وزنی</span>
              </div>
            </div>
            <input
              disabled
              ref="server"
              v-model="detailModel.wazn"
              type="text"
              class="form-control"
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from "vuex";
  import BaseService from "../_framework/api/BaseService.js";
  import Utils from "../_framework/utils/Utils.js";
  import VsSelect from "../_framework/VsSelect";
  import VsTableMixin from "../_framework/VsTableMixin.js";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Products from "../pages/Products.vue";
  import EventBus from "../bus.js";
  import ClientSelect from "../components/ClientSelect.vue";

  export default {
    name: "SetProductDetails",
    props: {
      headerKey: null,
      row: null,
      mode: {
        default: "view",
        type: String
      },
      params: {},
      options: {},
      entity: ""
    },
    mixins: [VsTableMixin],
    components: {
      VsSelect,
      datePicker: DatePicker
    },
    data() {
      return {
        show: false,
        modeee:"",
        product: {},
        modalTitle: "جزییات محصول",
        documentDate: null,
        servicesList: [],
        selectedServices: [],
        service: {
          id: 0,
          title: "",
          price: "",
          sessionQuantity: "",
          description: ""
        },
        detailModel: {
          id: 0,
          productId: 0,
          barcode: "",
          isoCode: "",
          customerName: "",
          standardName: "",
          weight: 0,
          tool: 0,
          arz: 0,
          ertefa: 0,
          color: "",
          ghotr: 0,
          standardName2: ""
        },

      };
    },
    mounted() {
      // this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
    },
    beforeMount() {
      if (this.row) {
        this.product = this.row;
        this.modalTitle = this.modalTitle + " " + this.product.productName;
      }

      // if (this.$route && this.$route.path) {
      //   this.tableOptions.access = checkAccess(this.$route.path);
      // } else {
      //   this.tableOptions.access = checkAccess("products");
      // }
    },
    methods: {
      openModal(mode) {
        this.modeee = mode;
        if(mode==='view') {
          this.show = true;
          this.detailModel.productId = this.product.id;
          new BaseService("Products/GetProductDetail").getById(this.product.id).then(rs => {
            this.detailModel = rs.data;
            this.detailModel.metrtool = Math.ceil(this.detailModel.tool * this.product.stockQuantity * 1000) / 1000;
            this.detailModel.metrmoraba = Math.ceil(this.detailModel.tool * this.detailModel.arz * this.product.stockQuantity * 1000) / 1000;
            this.detailModel.hajm = Math.ceil(this.detailModel.tool * this.detailModel.arz * this.detailModel.ertefa * this.product.stockQuantity * 1000) / 1000;
            this.detailModel.wazn = Math.ceil(this.detailModel.weight * this.product.stockQuantity * 1000) / 1000;
            if (this.detailModel.productId == 0) {
              this.detailModel.productId = this.product.id;
            }
          }).catch((error) => {
            this.detailModel.productId = this.product.id;
          });
        }
        if (this.$refs) {
          this.$refs.ProductDetaiModal.show();
        }
      },
      setDateFromDatePicker(date) {
        this.documentDate = date;
      },
      toggleDatePicker() {
        this.$refs.datePicker.togglePicker();
      },
      btnClicked() {
        this.$refs.ProductDetaiModal.show();
        this.calculatePrependWidth();
      },
      onProductDetaiModalOk() {
        if(this.modeee==='view') {
          new BaseService("Products/CreateProductDetail").create(this.detailModel).then(rs => {
            this.$noty.success("تغییرات با موفقیت ذخیره شد");
            // location.reload();
            // this.$router.go(0);
            EventBus.$emit("materialChanged");

          }).catch((error) => {
          });
        }
        else{

          this.$emit(
            "dataChanged",
            "detailVm",
            this.detailModel
          );
        }

      },

    },
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"])
    },
    watch: {}
  };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }
</style>
